import Crud from '../views/Uf/Crud'
import Entity from '../views/Uf/Add'

let routes = {
    path: '/ufs',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/ufs/add',
            name: 'NewUf',
            component: Entity,
            meta: {
                pageTitle: 'uf.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'uf.form.titleNew',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/ufs/edit/:id?',
            name: 'EditUf',
            component: Entity,
            meta: {
                pageTitle: 'uf.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'uf.form.titleEdit',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/ufs',
            name: 'list-ufs',
            component: Crud,
            meta: {
                pageTitle: 'uf.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'uf.title',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
